import { z } from "zod";

const iaFredInfoBlockZodObject = z.object({
    message: z.string(),
    suggestions: z.array(
        z.object({
            title: z.string(),
            content: z.string(),
        }),
    ),
});

type aiFredInfoBlock = z.infer<typeof iaFredInfoBlockZodObject>;
export { iaFredInfoBlockZodObject };
export type { aiFredInfoBlock };
